import {
  commonCiEnv,
  commonDevEnv,
  InjectableConfig,
  MfeTypes,
  updateAppBuildData,
  WindowedObservable,
} from '@procom-labs/common'

const dev = {
  ...commonDevEnv,
  FBO_ASSIGNMENTS_URL: process.env.FBO_ASSIGNMENTS_URL
    ? process.env.FBO_ASSIGNMENTS_URL
    : 'https://fbo-qa-reports-service.azurewebsites.net',
  GW_RULE_ENGINE_URL: process.env.GW_RULE_ENGINE_URL
    ? process.env.GW_RULE_ENGINE_URL
    : 'https://gw-dev-compliance-service.azurewebsites.net',
  IS_OB_SUBVENDOR_FEATURE_ENABLED:
    process.env.IS_OB_SUBVENDOR_FEATURE_ENABLED ?? 'false',
  IS_SELF_SERVE_OFFER_FEATURE_ENABLED:
    process.env.IS_SELF_SERVE_OFFER_FEATURE_ENABLED ?? 'false',
  IS_SELF_SERVE_PACKAGE_FEATURE_ENABLED:
    process.env.IS_SELF_SERVE_PACKAGE_FEATURE_ENABLED ?? 'false',
  PAYROLL_API_URL: process.env.PAYROLL_API_URL
    ? process.env.PAYROLL_API_URL
    : 'https://localhost:44321',
  RULE_ENGINE_URL: process.env.RULE_ENGINE_URL
    ? process.env.RULE_ENGINE_URL
    : 'https://procom-dev-ruleengine-service.azurewebsites.net',
}

const ci: typeof dev = {
  ...commonCiEnv,
  FBO_ASSIGNMENTS_URL: '#{FBO_ASSIGNMENTS_URL}#',
  GW_RULE_ENGINE_URL: '#{GW_RULE_ENGINE_URL}#',
  IS_OB_SUBVENDOR_FEATURE_ENABLED: '#{IS_OB_SUBVENDOR_FEATURE_ENABLED}#',
  IS_SELF_SERVE_OFFER_FEATURE_ENABLED:
    '#{IS_SELF_SERVE_OFFER_FEATURE_ENABLED}#',
  IS_SELF_SERVE_PACKAGE_FEATURE_ENABLED:
    '#{IS_SELF_SERVE_PACKAGE_FEATURE_ENABLED}#',
  PAYROLL_API_URL: '#{PAYROLL_API_URL}#',
  RULE_ENGINE_URL: '#{RULE_ENGINE_URL}#',
}

export const environment = {
  ...(process.env.REACT_APP_STAGE === 'ci' ? ci : dev),
}

if (process.env.NODE_ENV === 'development') {
  new WindowedObservable(InjectableConfig.Environment).publish(environment)
}

updateAppBuildData(
  MfeTypes.onboarding,
  process.env.REACT_APP_BUILD_NUMBER ?? null
)
